import styled from '@mui/styled-engine';
import { Typography } from '@mui/material';

export const StyledFieldTitle = styled(Typography)(
  () => `
  font-weight: bold;
`
);
